<template>
    <div class="slider-home">
        <div class="slider-home__head">
            <div class="slider-home__title">{{ sliderHeader }}</div>
            <a class="slider-home__link" @click="goToLink(sliderSub.link)">{{ sliderSub.text }}</a>
        </div>
        <div class="slider-home__slide">
            <div class="slider-home__slide-item" v-hammer:swipe.horizontal="(e) => sliderAdvance(e.type)">
                <div v-for="(slideItem, index) in this.slides" :key="index" class="slider-home__slide-content"
                     :style="`left: ${sliderPositions}px;`"
                >
                    <img class="slider-home__slide-image" :src="require(`@/assets/img/home_slider/${slideItem.image}`)">
                    <div class="slider-home__slide-text-container">
                        <span class="slider-home__slide-title">
                            {{slideItem.header}}
                        </span>
                        <span class="slider-home__slide-text">
                            {{slideItem.text}}
                        </span>
                        <a @click="goToLink(slideItem.link)" class="slider-home__slide-view">{{slideItem.linkText}}</a>
                    </div>
                </div>
            </div>
            <div class="slider-home__slide-left" @click="sliderAdvance('prev')"  v-if="this.slides.length > 1">
                <svg viewBox="0 0 14 24">
                    <path fill="#FFF"
                          d="M13.07 23.28c-.188 0-.37-.063-.504-.177L.778 13.25c-.468-.39-.731-.929-.731-1.491 0-.563.263-1.1.73-1.49L12.568.43c.13-.141.324-.228.532-.236.208-.01.41.06.556.19.145.13.218.307.202.487-.016.18-.121.346-.288.454L1.79 11.177c-.183.153-.285.363-.285.583 0 .22.102.43.285.583l11.78 9.852c.212.178.28.45.17.688-.11.237-.373.394-.669.397z"/>
                </svg>
            </div>
            <div class="slider-home__slide-right" @click="sliderAdvance('next')"  v-if="this.slides.length > 1">
                <svg viewBox="0 0 14 24">
                    <path fill="#FFF"
                          d="M.93.72c.188 0 .37.063.504.177l11.788 9.852c.468.39.731.929.731 1.491 0 .563-.263 1.1-.73 1.49l-11.79 9.84c-.13.141-.324.228-.532.236-.208.01-.41-.06-.556-.19-.145-.13-.218-.307-.202-.487.016-.18.121-.346.288-.454l11.78-9.852c.183-.153.285-.363.285-.583 0-.22-.102-.43-.285-.583L.43 1.805c-.212-.178-.28-.45-.17-.688C.371.88.634.723.93.72z"/>
                </svg>
            </div>
        </div>
        <div class="slider-home__pager" v-if="this.slides.length > 1">
            <span v-for="(slideItem, index) in this.slides" :key="index" class="slider-home__pager-dot"
                  :class="{'slider-home__pager-dot--active' : sliderIndex === index}" @click="sliderSeek(index)"/>
        </div>
    </div>
</template>

<script>

    export default {
        name: "SliderHome",
        props: ['slides', 'sliderTime','sliderHeader','sliderSub'],
        data() {
            return {
                sliderIndex: 0,
                sliderWidth: null,
                sliderInterVal: null,
                sliderFocus: false,
            }
        },
        computed: {
            sliderPositions() {
                return (this.sliderIndex * this.sliderWidth) * -1;
            }
        },
        methods: {
            sliderAdvance(type) {
                switch (type) {
                    case 'next':
                    case 'swipeleft':
                        this.sliderInitiate();
                        this.sliderIndex === this.slides.length - 1 ? this.sliderIndex = 0 : this.sliderIndex++;
                        break;
                    case 'prev':
                    case 'swiperight':
                        this.sliderInitiate();
                        this.sliderIndex === 0 ? this.sliderIndex = this.slides.length - 1 : this.sliderIndex--;
                        break;
                }
            },
            sliderSeek(index){
                this.sliderIndex = index;
                this.sliderInitiate();
            },
            sliderInitiate() {
                this.sliderInterval ? clearInterval(this.sliderInterval) : false;
                this.sliderWidth = document.querySelector('.slider-home__slide-item').offsetWidth;
                this.sliderInterval = window.setInterval(() => {
                    this.sliderAdvance('next');
                }, this.sliderTime * 1000);
            },
            goToLink(link) {
                if (link === '#') {
                    this.$router.push({name: 'Home'});
                } else if (link.includes('path:')) {
                    this.$router.push({path: link.replace('path:','')});
                } else if (link.includes('to:')) {
                    this.$router.push({name: link.replace('to:','')});
                } else if (link === "_fn") {
                    this['callback']();
                } else {
                    window.open(link);
                }
            }
        },
        mounted() {
            this.sliderInitiate();
            window.addEventListener('resize', () => {
                this.sliderIndex = 0;
                this.sliderInitiate();
            });
        },
        destroyed() {
            clearInterval(this.sliderInterval);
        }
    }
</script>

<style lang="scss">
    .slider-home {
        display: flex;
        width: 826px;
        flex-direction: column;
        position: relative;

        &__head {
            display: flex;
            justify-content: space-between;
            width: 100%;
            margin-bottom: 15px;
            padding: 0px 100px;
            box-sizing: border-box;
        }

        &__slide {
            display: flex;
            width: 100%;
            border-radius: 101px;
            position: relative;
            overflow: hidden;

            &-right {
                position: absolute;
                right: 14px;
                top: 50%;
                transform: translateY(-50%);
                margin: 0px auto;
                width: 14px;
                height: 24px;
                cursor: pointer;
            }

            &-left {
                position: absolute;
                left: 14px;
                top: 50%;
                transform: translateY(-50%);
                margin: 0px auto;
                width: 14px;
                height: 24px;
                cursor: pointer;
            }

            &-image {
                position: absolute;
                z-index: -1;
                width: 826px;
                left: 0px;
                top: 0px;
            }

            &-item {
                display: flex;
                align-items: center;
                flex-wrap: nowrap;
                width: 100%;
                height: 202px;
                border-radius: 101px;
            }

            &-content {
                display: inline-flex;
                flex-direction: column;
                width: 100%;
                min-width: 100%;
                height: 100%;
                align-items: flex-start;
                justify-content: center;
                position: relative;
                transition: all 800ms ease-in-out;
                cursor: grab;
            }

            &-text-container {
                display: flex;
                flex-direction: column;
                margin-left: 70px;
            }

            &-title,
            &-text {
                font-size: 18px;
                font-weight: normal;
                font-stretch: normal;
                font-style: normal;
                line-height: normal;
                letter-spacing: normal;
                color: #ffffff;
            }

            &-text {
                width: 370px;
                display: block;
                min-height: 70px;
                @media only screen and (max-device-width: 768px) {
                    width: 100%;
                }
            }

            &-title {
                font-weight: bold;
            }

            &-view {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 100px;
                height: 22px;
                border-radius: 27px;
                border: solid 1px #ffffff;
                font-size: 12px;
                font-weight: bold;
                font-stretch: normal;
                font-style: normal;
                line-height: normal;
                letter-spacing: normal;
                color: #ffffff;
                text-decoration: none;
                margin-top: 15px;
                cursor: pointer;

                &:hover {
                    background-color: white;
                    color: black;
                }
            }
        }

        &__title {
            font-size: 15px;
            font-weight: bold;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            color: #ffffff;
            @media only screen and (max-device-width: 768px) {
                font-size: 38px;
            }
        }

        &__link {
            font-size: 15px;
            font-weight: bold;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            color: #ffffff;
            text-decoration: underline;
            cursor: pointer;
            @media only screen and (max-device-width: 768px) {
                font-size: 38px;
            }
        }

        &__pager {
            display: flex;
            justify-content: center;
            align-items: center;
            margin-top: 20px;

            &-dot {
                width: 26px;
                height: 8px;
                border-radius: 100px;
                background-color: #979797;
                margin: 0px 7px;
                transition: all 0.5s;

                &--active {
                    background-color: white;
                    width: 72px;
                }

                &:hover {
                    background-color: white;
                    width: 72px;
                    cursor: pointer;
                }
            }
        }

        @media only screen and (max-device-width: 768px) {
            width: 100%;
            &__slide {
                border-radius: 50px;

                &-item {
                    height: 400px;
                }

                &-content {
                    overflow: hidden;

                    img {
                        width: auto;
                        min-height: 100%;
                        height: 100%;
                        margin-right: auto;
                        display: block;
                        left: initial;
                        right: 0;
                    }
                }

                &-content::before {
                    content: '';
                    width: 100%;
                    height: 100%;
                    position: absolute;
                    background: linear-gradient(to left, transparent 0%, black 130%);
                }

                &-title {
                    font-size: 48px;
                    width: 50%;
                    z-index: 99;
                }

                &-left,
                &-right {
                    width: 34px;
                    height: 64px;
                }

                &-text-container {
                    width: 80%;
                    height: 100%;
                    margin: 0 auto;
                }
                

                &-title {
                    width: 100%;
                    max-width: 100%;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    margin-top: auto;
                }

                &-text {
                    width: 100%;
                    height: 120px;
                    display: flex;
                    flex-direction: column;
                    font-size: 36px;
                    z-index: 99;
                }

                &-view {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 203px;
                    height: 72px;
                    border-radius: 87px;
                    border: solid 1px #ffffff;
                    font-size: 36px;
                    font-weight: bold;
                    font-stretch: normal;
                    font-style: normal;
                    line-height: normal;
                    letter-spacing: normal;
                    color: #ffffff;
                    text-decoration: none;
                    margin-top: 15px;
                    margin-bottom: 35px;
                    z-index: 99;
                }
            }
        }
    }
</style>
